import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { LogtoProvider } from '@logto/react';
import { Provider as ReduxProvider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { retrieveLaunchParams } from '@tma.js/sdk-react';

import { store } from '@/store';
import { router } from '@/routes/router';
import { i18n } from '@/lib/i18n';
import { initTelegram } from '@/lib/telegram';
import { logtoConfig } from '@/lib/logto';
import { EnvUnsupported } from '@/components/common/EnvUnsupported';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { env } from '@/env';

import './styles/globals.css';
import { setupMockEnv } from './mockEnv';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');
const root = ReactDOM.createRoot(rootEl);

async function bootstrap() {
  try {
    await setupMockEnv();

    const launchParams = retrieveLaunchParams();
    const platform = launchParams.tgWebAppPlatform;
    const debug = (launchParams.tgWebAppStartParam || '').includes('debug') || env.isDev;

    await initTelegram({
      debug,
      eruda: debug && env.enableEruda && ['ios', 'android'].includes(platform),
      mockForMacOS: platform === 'macos',
    });

    root.render(
      <StrictMode>
        <ErrorBoundary>
          <LogtoProvider config={logtoConfig}>
            <ReduxProvider store={store}>
              <I18nextProvider i18n={i18n}>
                <RouterProvider router={router} />
              </I18nextProvider>
            </ReduxProvider>
          </LogtoProvider>
        </ErrorBoundary>
      </StrictMode>,
    );
  } catch (err) {

    console.error('[bootstrap] failed to initialize:', err);
    root.render(<EnvUnsupported />);
  }
}

void bootstrap();
